/*
 * @Description: 
 * @Autor: cherry
 * @Date: 2022-05-19 13:34:49
 * @LastEditors: cherry
 * @LastEditTime: 2022-05-20 10:38:30
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace Hd {
    /**
    * 获取回单列表
    */
    export var getList = (query: any): Promise<any> => {
        return Get(`/msls/Receipt/GetList?${qs.stringify(query)}`, {});
    };
    /**
    * 导出
    */
     export var Export = (query: any): Promise<any> => {
        return Download(`/msls/Receipt/Export?${qs.stringify(query)}`, {});
    };
    /**
    * 回单预览
    */
    export var viewHd = (id: string): Promise<any> => {
        return Get(`/msls/Receipt/View/${id}`, {});
    };
    /**
    * 上传回单
    */
     export var signHd = (id: any): Promise<any> => {
        return Put(`/msls/Receipt/Sign/${id}`, {});
    };
    /**
     * 获取客户/基地名称下拉
     */
     export var GetDropDownList = (query):Promise<any> =>{
        return Get(`/msls/CustomerBase/GetDropDownList?${qs.stringify(query)}`,{});
    }
    /**
     * 获取车队
     */
     export var GetCarrierList =(data):Promise<any> =>{
        return Get(`/msls/Carrier/GetCarrierList?${qs.stringify(data)}`,{});
    }
}
